import { documentReady } from "./utils/dom"

function getStoreUrl() {
  const ua = (navigator.userAgent || "").toLowerCase()
  if (ua.includes("android")) {
    return "https://play.google.com/store/apps/details?id=de.machtfit.poc"
  }
  return "https://apps.apple.com/de/app/machtfit/id1116916354"
}

const UPDATE_OVERLAY_STORAGE_KEY = "update-overlay-dismissed-3.0.0"

documentReady(() => {
  const overlay = document.getElementById("update-overlay")
  if (!overlay) return

  const dismissed =
    window.localStorage && window.localStorage.getItem(UPDATE_OVERLAY_STORAGE_KEY) === "1"

  if (!dismissed) {
    overlay.style.display = "flex"
  }

  const closeBtn = document.getElementById("update-overlay-close-btn")
  const updateBtn = document.getElementById("update-overlay-update-btn")

  closeBtn.addEventListener("click", () => {
    if (window.localStorage) {
      window.localStorage.setItem(UPDATE_OVERLAY_STORAGE_KEY, "1")
    }
    overlay.style.display = "none"
  })

  updateBtn.addEventListener("click", () => {
    if (window.localStorage) {
      window.localStorage.setItem(UPDATE_OVERLAY_STORAGE_KEY, "1")
    }
    window.open(getStoreUrl(), "_blank")
  })
})
